export const getRangeTitle = (t, range) => {
  if (!range.maxSalary) {
    return t("components.UserManagementContent.salaryRangeMaxFormat", {
      value: range.minSalary / 1000,
    });
  } else {
    return t(
      range.minSalary === 0
        ? "components.UserManagementContent.salaryRangeMinFormat"
        : "components.UserManagementContent.salaryRangeFormat",
      {
        min: range.minSalary / 1000,
        max: range.maxSalary / 1000,
      }
    );
  }
};
